import { render, staticRenderFns } from "./farm-todos.vue?vue&type=template&id=3bdd5ee8"
import script from "./farm-todos.vue?vue&type=script&lang=js"
export * from "./farm-todos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports